import * as React from 'react'
import type { ViewableReport } from '../../../../shared/domain/viewableReports/types.no-deps'
import { ViewFlowItems } from './ViewFlowItems'
import type { SharedProps } from './SharedProps'
import { ViewFlowGroups } from './ViewFlowGroups'
import { GroupWrapper } from './GroupWrapper'
import classNames from 'classnames'

interface Props extends SharedProps {
    report: ViewableReport
    bare?: boolean
    showAnswerHistory?: boolean
}

export class ViewReport extends React.Component<Props> {
    public render = () => {
        const { report } = this.props

        return (
            <div
                className={classNames('AppCore__report__ViewReport', {
                    'AppCore__report__ViewReport--bare': this.props.bare,
                })}
            >
                {report.answers.length > 0 && (
                    <GroupWrapper>
                        <ViewFlowItems
                            {...this.props}
                            items={report.answers.map((answer) => ({ type: 'answer', answer }))}
                            unitData={report.subjectUnit?.data}
                        />
                    </GroupWrapper>
                )}

                {report.flowGroups && report.flowGroups.length !== 0 && (
                    <div className="AppCore__report__FlowGroups">
                        <ViewFlowGroups
                            {...this.props}
                            flowGroups={report.flowGroups}
                            flow={report.flow}
                            cachedUnitData={report.cachedUnitData}
                            subjectUnitData={report.subjectUnit?.data}
                        />
                    </div>
                )}
            </div>
        )
    }
}
